<div class="billing-info-wrapper">
  <ion-item class="summary-tab" button color="-ion-color-white" lines="none" detail='false'>
    <div></div>
    <ion-label>
      <div class="summary-header dark-teal-2">Billing Information</div>
    </ion-label>
  </ion-item>
  <div class="summary-list">
    <form [formGroup]="payment_form" (ngSubmit)="submit()">
      <ion-list class="billing-list">
        <div class="inline-inputs-container">
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">Full Name</ion-label>
            <ion-input type="text" class="basic-inputs" formControlName="name"></ion-input>
          </ion-item>
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">Address</ion-label>
            <ion-input type="text" class="basic-inputs" formControlName="address_line1"></ion-input>
          </ion-item>
        </div>
        <div class="inline-inputs-container">
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">City</ion-label>
            <ion-input type="text" class="basic-inputs" formControlName="address_city"></ion-input>
          </ion-item>
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">State / Province</ion-label>
            <ion-input type="text" class="basic-inputs" formControlName="address_state"></ion-input>
          </ion-item>
        </div>
        <div class="inline-inputs-container">
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">Postal Code</ion-label>
            <ion-input type="text" class="basic-inputs" formControlName="address_zip"></ion-input>
          </ion-item>
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">Country</ion-label>
            <ion-select formControlName="country" class="basic-select country-select" [interfaceOptions]="countryAlert">
              <ion-select-option
                *ngFor="let country of (toolService.content | async)?.countries; let i = index; trackBy: trackByIndex;"
                value="{{country}}">
                {{country}} </ion-select-option>
            </ion-select>
          </ion-item>
        </div>
        <div class="inline-inputs-container">
          <ion-item lines="none" class="inline-billing-inputs">
            <ion-label position="stacked">Email</ion-label>
            <ion-input type="email" class="basic-inputs" formControlName="email"></ion-input>
          </ion-item>
          <!-- <ion-item>
            <ion-label position="stacked">Phone Number</ion-label>
            <ion-input type="tel" class="basic-inputs" formControlName="phone"></ion-input>
          </ion-item> -->
        </div>
      </ion-list>
    </form>
  </div>
</div>
